import { Chip } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import type { SessionSearchItem, SessionSearchItemMatchedBy } from '../../api/model';

const MATCHED_BY_LABELS: Record<SessionSearchItemMatchedBy, string> = {
  framed_ipv4: 'Framed IPv4',
  framed_ipv6: 'Framed IPv6 (/128)',
  delegated_prefix: 'Delegated prefix (/56)',
};

const utcFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'UTC',
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
  timeZoneName: 'short',
});

const displayValue = (value: string | null | undefined) => (value?.trim() ? value : '—');

const formatUtcTimestamp = (value: string) => utcFormatter.format(new Date(value));

export const sessionSearchColumns: Array<GridColDef<SessionSearchItem>> = [
  {
    field: 'username',
    headerName: 'Username',
    width: 160,
  },
  {
    field: 'framed_ip_address',
    headerName: 'Framed IPv4',
    width: 140,
    valueGetter: (_value, row) => displayValue(row.framed_ip_address),
  },
  {
    field: 'framed_ipv6_address',
    headerName: 'Framed IPv6',
    width: 180,
    valueGetter: (_value, row) => displayValue(row.framed_ipv6_address),
  },
  {
    field: 'delegated_ipv6_prefix',
    headerName: 'Delegated IPv6 PD',
    width: 180,
    valueGetter: (_value, row) => displayValue(row.delegated_ipv6_prefix),
  },
  {
    field: 'agent_circuit_id',
    headerName: 'Agent Circuit ID',
    flex: 1,
    minWidth: 160,
    valueGetter: (_value, row) => displayValue(row.agent_circuit_id),
  },
  {
    field: 'acct_start_time',
    headerName: 'Session start (UTC)',
    width: 200,
    valueGetter: (_value, row) => formatUtcTimestamp(row.acct_start_time),
  },
  {
    field: 'acct_stop_time',
    headerName: 'Session stop (UTC)',
    width: 200,
    valueGetter: (_value, row) => (row.acct_stop_time ? formatUtcTimestamp(row.acct_stop_time) : 'Active'),
  },
  {
    field: 'matched_by',
    headerName: 'Matched by',
    width: 180,
    renderCell: (params) => (
      <Chip label={MATCHED_BY_LABELS[params.row.matched_by]} size="small" variant="outlined" />
    ),
  },
];
